import React, { useState } from 'react';
import { TaskData } from '../../../api/endpoints/tasks';
import { Icon } from '../../../concepts/resources/Icon';
import { LabelValue } from '../../../platform/types/LabelValue';
import { Colors, Menu } from '../../../ui';
import { BadgeButton } from '../../../ui/BadgeButton';
import { Popover } from '../../canvas/ui/Popover';
import { Flexer, Title } from '../elements/LayoutElements';
import { useOnPatchTask } from './TaskActions';

const opts = [
    LabelValue('TO DO', { id: 'open', color: Colors.gray200 }),
    LabelValue('DONE', { id: 'done', color: Colors.positive }),
    LabelValue('WON\'T DO', { id: 'closed', color: Colors.rose800 }),
];

type TaskStatusMenuProps = {
    active?: string,
    onSelect: (next: string) => void,
};

export const TaskStatusMenu = React.memo(({ active, onSelect }: TaskStatusMenuProps) => {

    return <Flexer width="12">
        <Flexer padding=".5 1" background={Colors.gray50} borderRadius=".5rem .5rem 0 0" borderBottom={`1px solid ${Colors.borderLight}`}>
            <Title flush size="2xs" color={Colors.text} uppercase weight="500">Change To:</Title>
        </Flexer>
        <Menu>
            {opts.filter(x => x.value.id !== active).map(x =>
                <Menu.Item key={x.value.id} onClick={() => onSelect(x.value.id)}>
                    <BadgeButton color={x.value.color}>
                        {x.label}
                    </BadgeButton>
                </Menu.Item>
            )}
        </Menu>
    </Flexer>;
});

export const TaskStatusCell = React.memo(({ readonly, task }: { readonly?: boolean, task: TaskData }) => {

    const { status } = (task);
    const option = opts.find(x => x.value.id === status);

    const [open, setOpen] = useState(false);

    const onPatchTask = useOnPatchTask(task.id);
    const onSelect = (next: string) => {
        onPatchTask({ status: next });
        setOpen(false);
    };


    if (!option) return null;

    return <Popover
        placement="bottom-start"
        content={<TaskStatusMenu active={status} onSelect={onSelect} />}
        inner={{ direction: 'down' }}
        open={open}
        onOpenChange={setOpen}
        disabled={readonly}
    >
        <BadgeButton color={option.value.color}>
            {option.label}
            {!readonly && <Icon size="1" src="deqo://icons/hero-mini/chevron-down" />}
        </BadgeButton>
    </Popover>;
});
